export default __webpack_public_path__ + "static/media/physics.9aee908b.gif";